import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserContext } from '../../../context/provider/UserProvider';
import { useHistory } from "react-router-dom";
// import LogoAbexa2018 from '../../../assets/images/LogoAbexa2018.png'
import { SocketContext } from '../../../context/provider/SocketProvider'
import { Timer } from './Timer';
import { Slideshow, Slide } from '../../components/utils/SliderShow';
import logoAbexa from '../../../assets/images/LogoAbexa-Web.png'
import { BotonMenuPrincipal } from '../../components/utils/BotonMenuPrincipal';
import { BotonNotificaciones } from '../../components/utils/BotonNotificaciones';
import { notify } from '../../../utils/utils';

export const Header = ({openMenu}) => {

    const dropDownSesion = useRef(null)
    const [ mostrarSesion, setMostrarSesion ] = useState(false)
    const { stateUser, signOut } = useContext(UserContext)
    const { mqttDisconnect, stateSocket } = useContext(SocketContext)
    const history = useHistory();
    useEffect(() => {
        if(Object.keys(stateSocket.payload).length > 0){
            if(stateSocket.payload.message){
                notify(stateSocket.payload.message.bd.mensaje, 'info');
                // setNumIcono(i => i +1)
            }
        }
    },[stateSocket.payload])

    useEffect(()=> {
        document.addEventListener('mousedown',(event) =>{
            if(mostrarSesion && dropDownSesion.current &&
                !dropDownSesion.current.contains(event.target)
            ){
                setMostrarSesion(false)
            }
        })
    },[mostrarSesion])


    const singOutSession = () => {
        mqttDisconnect();
        signOut()
        history.push('/')
    }

    const irPrincipal=()=>{
        history.push(localStorage.getItem('modulo'))
    }


    return (
        <>
            <div className="header">
                <nav className='h-full'>
                    <div
                        className="w-full h-full px-4 lg:px-2 grid lg:grid-cols-[10%_50%_40%] lg:items-center grid-cols-[20%_80%]"
                    >
                        <button
                            onClick={openMenu}
                            className="lg:w-[30px] lg:h-[30px] rounded-md text-gray-400 bg-gray-700
                            focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white hidden lg:block"
                            aria-controls="mobile-menu"
                        >
                            <i className="fas fa-bars text-[20px]"></i>
                        </button>
                        <main className='m-0 flex items-stretch' >
                            <Slideshow  controles={false} autoplay={true} velocidad="1500" intervalo="4000">
                                <Slide className='flex items-center justify-center'>
                                    <img
                                        src={logoAbexa}
                                        className='lg:max-w-[180px] lg:h-[50px]  max-w-[250px]  cursor-pointer'
                                        onClick={()=>irPrincipal()}
                                        alt=""
                                    />
                                </Slide>
                                <Slide className='flex items-center justify-center'>
                                    <img
                                        src={logoAbexa}
                                        className='lg:max-w-[180px] max-w-[250px] lg:h-[50px] cursor-pointer'
                                        onClick={()=>irPrincipal()}
                                        alt=""
                                    />
                                </Slide>
                            </Slideshow>
                        </main>
                        <div className='grid lg:grid-rows-2 grid-rows-[50%_50%] justify-end'>
                            <div className='flex justify-end'>
                                <Timer/>
                            </div>
                            <div className='flex gap-x-1 items-center'>
                                    <BotonNotificaciones/>
                                <button onClick={() => setMostrarSesion(!mostrarSesion)} className="px-1 py-1 hover:bg-blue-600 rounded">
                                    <span className="text-[15px] flex gap-2 items-center">
                                        <i className='fa fa-user'/>
                                        <span className='lg:hidden '>
                                            { stateUser?.nomUsuario }
                                        </span>
                                    </span>
                                </button>
                                <div
                                    ref={dropDownSesion}
                                    className={`absolute top-[40px] ${mostrarSesion ? '' : 'hidden'} right-0 z-50 w-44 bg-white rounded shadow dark:bg-[#003478]`}
                                >
                                    <ul className="py-1 text-sm text-white-700 dark:text-white-900" aria-labelledby="dropdownButton">
                                        <li><a onClick={() => singOutSession()} className="block py-2 px-4 hover:bg-blue-100 dark:hover:bg-blue-600 dark:hover:text-white">Cerrar Sesión</a></li>
                                    </ul>
                                </div>
                                <BotonMenuPrincipal/>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )

}